import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SharedModule } from "./../../shared/shared.module";
import { NgModule } from "@angular/core";
import { ProjectRoutingModule } from "./project-routing.module";
import { ProjectListComponent } from "./pages/project-list/project-list.component";
import { TableModule } from "primeng/table";
import { AppHttpClient } from "src/app/core-features/auth-guard/http-client.service";
import { ProjectService } from "./services/project.service";
import { CommonModule } from "@angular/common";
import { MatDialogModule } from "@angular/material/dialog";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxTagsInputModule } from "ngx-tags-input";
import { CreateProjectComponent } from "./component/create-project/create-project.component";
import { DropdownModule } from "primeng/dropdown";
import { PaginatorModule } from "primeng/paginator";

@NgModule({
  declarations: [ProjectListComponent, CreateProjectComponent],
  imports: [
    ProjectRoutingModule,
    CommonModule,
    TableModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    DropdownModule,
    NgxTagsInputModule,
    NgbModule,
    PaginatorModule
  ],
  exports: [CreateProjectComponent],
  providers: [AppHttpClient, ProjectService]
})
export class ProjectModule {}
